import { getData as apiGetData } from 'api/Api'
import {
  setPermissionLevel
} from '../redux/view'

type Payload = {
  boardId: number
}

export default (payload: Payload) => async dispatch => {
  const { boardId } = payload

  const { PermissionLevel } = await apiGetData('PermissionsForBoard', {
    boardId
  })

  dispatch(setPermissionLevel({
    boardId,
    permissionLevel: PermissionLevel
  }))

  return PermissionLevel
}
